import { countDecimals } from "../utils";
import _ from "lodash";

export default {
  computed: {
    rules: {
      get() {
        const self = this;
        return {
          required(value) {
            return (
              (typeof value === "number" && value >= 0) ||
              (Array.isArray(value) && value.length > 0) ||
              (typeof value === "string" && !!value) ||
              (typeof value === "object" && value !== null) ||
              self.$t("rules.required")
            );
          },
          maxLength(value, max) {
            let compiled = _.template(self.$t("rules.max"));
            return !value || value.length <= max || compiled({ max });
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !value || pattern.test(value) || "รูปแบบ e-mail ไม่ถูกต้อง";
          },
          mustEqual(value, equal) {
            return (
              !value || value.length === equal || `ต้องมี ${equal} ตัวอักษร`
            );
          },
          decimalDigit(v, d) {
            return !v || countDecimals(v) <= d || `ทศนิยมไม่เกิน ${d} ตำแหน่ง`;
          },
          isNumber(v) {
            return (typeof v === "number" && !isNaN(v)) || "จำนวนไม่ถูกต้อง";
          },
          max(value, max, label) {
            return (
              !value || +value <= max || (label ? label : `ต้องไม่เกิน ${max}`)
            );
          },
          min(value, min) {
            return !value || +value >= min || `อย่างน้อยต้อง ${min}`;
          }
        };
      }
    }
  }
};
